import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import '@coachtools/tokens/tokens.css';
import './styles/layout.css';
import './styles/screens.css';
/* The coach's grid is the one screen that is not a phone screen, and its rules
 * are about one route. Its own file keeps layout.css from growing a section
 * nothing else reads. layout.css was split on 25 September for the same
 * reason: the shell stays there, the screens live in screens.css, and both
 * are back under NM-06's 400 lines. */
import './styles/hours.css';
import './styles/coach-lessons.css';
import './styles/released.css';
import './styles/cancelling.css';
import './styles/consent.css';
import './styles/athlete-sign-in.css';
import './styles/lesson-videos.css';
import './styles/coach-lesson-list.css';
import './styles/clients.css';
import './styles/signature.css';
import './styles/teams.css';
import './styles/spreadsheet-import.css';
import './styles/recul.css';
import './styles/credits.css';
import './styles/clinics.css';
import './styles/progress.css';
import './styles/practices.css';
import { AuthProvider } from './auth/auth-provider.js';
import { router } from './routes.js';
import { reloadAfterDeploy } from './reload-after-deploy.js';
import { savedTheme } from './saved-theme.js';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

// Before anything renders, so the first lazy screen is already covered.
reloadAfterDeploy();

// Also before anything renders, so no screen flashes the other theme first.
savedTheme.apply(savedTheme.read());

/*
 * AuthProvider sits OUTSIDE the router. A sign-in redirect returns to the app
 * with its response in the URL fragment, and that has to be consumed before any
 * route renders - otherwise the first route to ask for a token does so against
 * an uninitialised MSAL instance, and the error names neither the cause nor the
 * place.
 */
createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>,
);
